import { useCallback } from "react";
import { fetchMailchimpDashboardStatus, getCachedMailchimpDashboardStatus } from "../api/dashboard.api";
import { useCachedDashboardQuery } from "./useCachedDashboardQuery";

export const useMailchimpDashboardStatus = (enabled: boolean) => {
  const fetcher = useCallback((force?: boolean) => fetchMailchimpDashboardStatus(force), []);
  return useCachedDashboardQuery(enabled, getCachedMailchimpDashboardStatus, fetcher);
};
